import { getBooksPk } from "@services/books";
import {
    getPageProfile,
    postPageProfile,
    putPageProfile,
    deletePageProfile,
} from "@services/page-profile";
import { getPNLSummary } from "@services/pnlSummary";
import deepClone from "deep-clone";
import { getLotDigits } from "@services/functional-api";
import i18n from "@/i18n";

const state = {
    socketUrl: document.querySelector("body").getAttribute("socketurl")
        ? document.querySelector("body").getAttribute("socketurl") +
          "/publisher-book-svc"
        : process.env.VUE_APP_SOCKET_BOOK,
    socketLoginUrl: document.querySelector("body").getAttribute("socketurl")
        ? document.querySelector("body").getAttribute("socketurl") +
          "/publisher-user-svc"
        : process.env.VUE_APP_SOCKET_IB,
    briefData: null,
    mainBookTitleDesc: {
        unrealized: i18n.t("monitor.home.unrealizedDescription"),
        realized: i18n.t("monitor.home.realizedDescription"),
        dailyNet: i18n.t("monitor.home.dailyNetDescription"),
    },
    mainBookTitle: { unrealized: 0, realized: 0, dailyNet: 0 },
    briefHeader: [
        {
            text: "Book",
            value: "book",
            align: "start",
            // width: 120,
            sortable: true,
            class: "bookHeader",
        },
        {
            text: "NPNL",
            value: "NPNL",
            align: "end",
            class: "NPNLHeader",
        },
        {
            text: "CPNL",
            value: "CPNL",
            align: "end",
            class: "CPNLHeader",
        },
        {
            text: "FPNL",
            value: "FPNL",
            align: "end",
            class: "FPNLHeader",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
            class: "dailyVolumeUSDHeader",
        },
        {
            text: i18n.t("common.table.netEquity"),
            value: "NetEquity",
            align: " d-none",
            class: "NetEquityHeader",
        },
        {
            text: "MTD PNL",
            value: "mtdPnl",
            align: " d-none",
            class: "mtdPnlHeader",
        },
        {
            text: "MTD Vol",
            value: "mtdVol",
            align: " d-none",
            class: "mtdVolHeader",
        },
    ],
    briefChildrenHeader: [
        {
            text: "Book",
            value: "book",
            align: "start",
            // width: 120,
            sortable: true,
        },
        {
            text: "NPNL",
            value: "NPNL",
            align: "end",
        },
        {
            text: "CPNL",
            value: "CPNL",
            align: "end",
        },
        {
            text: "FPNL",
            value: "FPNL",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
        },
        {
            text: i18n.t("common.table.netEquity"),
            value: "NetEquity",
            align: " d-none",
        },
        {
            text: "MTD PNL",
            value: "mtdPnl",
            align: " d-none",
        },
        {
            text: "MTD Vol",
            value: "mtdVol",
            align: " d-none",
        },
    ],
    pkData: [],
    pkHeaders: [
        {
            text: i18n.t("common.table.symbol"),
            value: "symbol",
            align: "start",
        },
        {
            text: i18n.t("common.table.long"),
            value: "longPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.short"),
            value: "shortPositions",
            align: "end",
        },
        { text: i18n.t("common.table.netLot"), value: "net", align: "end" },
        {
            text: i18n.t("common.table.exposure"),
            value: "symbolExposure",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyNet"),
            value: "dailyNet",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedEod"),
            value: "floatingProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedEod"),
            value: "closedProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedMT"),
            value: "floatingProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedMT"),
            value: "closedProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
        },
        {
            text: i18n.t("common.table.longVwap"),
            value: "weightedAvgLongPrice",
            align: "end",
        },
        {
            text: i18n.t("common.table.shortVwap"),
            value: "weightedAvgShortPrice",
            align: "end",
        },
    ],
    pkLoginHeaders: [
        { text: i18n.t("common.table.login"), value: "Login", align: "start" },
        { text: i18n.t("common.table.name"), value: "Name", align: "start" },
        {
            text: i18n.t("common.table.exposure"),
            value: "Exposure",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyNet"),
            value: "dailyNet",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedEod"),
            value: "floatingProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedEod"),
            value: "closedProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedMT"),
            value: "floatingProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedMT"),
            value: "closedProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.totalPnlMT"),
            value: "TodayTotalMTPNL",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
        },
        {
            text: i18n.t("common.table.equity"),
            value: "Equity",
            align: "end",
        },
        {
            text: i18n.t("common.table.freeMargin"),
            value: "MarginFree",
            align: "end",
        },
        {
            text: i18n.t("common.table.credit"),
            value: "Credit",
            align: "end",
        },
        {
            text: i18n.t("common.table.marginLevel"),
            value: "MarginLevel",
            align: "end",
        },
    ],
    subTableHeader: [
        { text: i18n.t("common.table.login"), value: "login", align: "start" },
        {
            text: i18n.t("common.table.long"),
            value: "longPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.short"),
            value: "shortPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.netLot"),
            value: "netPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.exposure"),
            value: "exposure",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyNet"),
            value: "dailyNet",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedEod"),
            value: "floatingProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedEod"),
            value: "closedProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedMT"),
            value: "floatingProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedMT"),
            value: "closedProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
        },
        {
            text: i18n.t("common.table.longVwap"),
            value: "weightedAvgLongPrice",
            align: "end",
        },
        {
            text: i18n.t("common.table.shortVwap"),
            value: "weightedAvgShortPrice",
            align: "end",
        },
    ],
    subLoginTableHeader: [
        {
            text: i18n.t("common.table.symbol"),
            value: "symbol",
            align: "start",
        },
        {
            text: i18n.t("common.table.long"),
            value: "longPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.short"),
            value: "shortPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.netLot"),
            value: "netPositions",
            align: "end",
        },
        {
            text: i18n.t("common.table.exposure"),
            value: "exposure",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyNet"),
            value: "dailyNet",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedEod"),
            value: "floatingProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedEod"),
            value: "closedProfitEOD",
            align: "end",
        },
        {
            text: i18n.t("common.table.unrealizedMT"),
            value: "floatingProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.realizedMT"),
            value: "closedProfit",
            align: "end",
        },
        {
            text: i18n.t("common.table.dailyVolumeUSD"),
            value: "dailyVolumeUSD",
            align: "end",
        },
        {
            text: i18n.t("common.table.longVwap"),
            value: "weightedAvgLongPrice",
            align: "end",
        },
        {
            text: i18n.t("common.table.shortVwap"),
            value: "weightedAvgShortPrice",
            align: "end",
        },
    ],
    books: [],
    selectedBook: "",
    exposureData: null,
    csvFields: {
        Symbol: "symbol",
        Long: "longPositions",
        Short: "shortPositions",
        "Net Lot": "net",
        Exposure: "symbolExposure",
        "Daily Net": "dailyNet",
        "Unrealized (EOD)": "floatingProfitEOD",
        "Realized (EOD)": "closedProfitEOD",
        "Unrealized (MT)": "floatingProfit",
        "Realized (MT)": "closedProfit",
        "Daily Volume (USD)": "dailyVolumeUSD",
        "Long VWAP": "weightedAvgLongPrice",
        "Short VWAP": "weightedAvgShortPrice",
    },
    csvLoginFields: {
        Login: "Login",
        Exposure: "Exposure",
        "Daily Net": "dailyNet",
        "Unrealized (EOD)": "floatingProfitEOD",
        "Realized (EOD)": "closedProfitEOD",
        "Unrealized (MT)": "floatingProfit",
        "Realized (MT)": "closedProfit",
        "Total PNL (MT)": "TodayTotalMTPNL",
        "Daily Volume (USD)": "dailyVolumeUSD",
        Equity: "Equity",
        "Free Margin": "MarginFree",
        Credit: "Credit",
        "Margin Level(%)": "MarginLevel",
    },
    allBookCsvFields: {
        Book: "book",
        NPNL: "NPNL",
        CPNL: "CPNL",
        FPNL: "FPNL",
        dailyBuyVolumeUSD: "dailyVolumeUSD",
        "Net Equity": "NetEquity",
        "MTD PNL": "mtdPnl",
        "MTD Vol": "mtdVol",
    },
    isSocketConnected: false,
    allBookOptions: [],
    unwantedBooks: [],
    allProfile: [{ id: 0, text: "default", books: [] }],
    selectedProfile: {},
    editingDialog: null,
    updated: false,
    isBtnDisabled: false,
    dialogLoading: false,
    bookMap: null,
    PNLSummaryData: [],
    loading: false,
    selectedInterval: 1000,
    allBookIntervalOptions: [
        { key: i18n.t("common.time.03s"), value: 300 },
        { key: i18n.t("common.time.05s"), value: 500 },
        { key: i18n.t("common.time.1s"), value: 1000 },
        { key: i18n.t("common.time.5s"), value: 5000 },
        { key: i18n.t("common.time.10s"), value: 10000 },
        { key: i18n.t("common.time.push"), value: -1 },
    ],
    symbolSnapshotData: {},
    loginSnapshotData: {},
    homeTutorial: false,
    homeSymbolTutorial: false,
    homeSymbolSnapshotTutorial: false,
    homeLoginTradesTutorial: false,
    homeLoginInfoTutorial: false,
    homeLoginSnapshotTutorial: false,
    lotDigits: 2,
    exposureData: {},
};

const actions = {
    getBooksPkAction({ commit, state }, params) {
        commit("UPDATE_BOOKS", []);
        commit("UPDATE_BRIEF_DATA", []);
        getBooksPk().then((res) => {
            commit("UPDATE_ALL_BOOK_OPTIONS", res.data);
        });
    },
    getLotDigitsAction({ commit }) {
        getLotDigits().then((res) => {
            commit("UPDATE_LOT_DIGITS", res.data);
        });
    },
    calculateAllBooks({ commit, state }, data) {
        const result = state.briefData;
        const currentBook = data.book;

        const index = state.bookMap.findIndex(
            (item) => item.name == currentBook
        );

        const newRow = deepClone(result[index]);
        const last = result[index].NPNL;
        const lastClosed = result[index].CPNL;
        const lastClosedColor = result[index]?.closedColor;

        newRow.NPNL = (data.floatingProfitsEOD + data.closedProfitsEOD).toFixed(
            2
        );
        newRow.CPNL = data.closedProfitsEOD;

        newRow.FPNL = data.floatingProfitsEOD;
        newRow.NetEquity = data.NetEquity;
        newRow.dailyVolumeUSD = data?.dailyVolumeUSD ?? 0;

        newRow.color =
            Number(newRow.NPNL) > Number(last)
                ? "#27ae60"
                : Number(newRow.NPNL) < Number(last)
                ? "#c0392b"
                : "";
        newRow.closedColor =
            Number(newRow.CPNL) > Number(lastClosed)
                ? "#27ae60"
                : Number(newRow.CPNL) < Number(lastClosed)
                ? "#c0392b"
                : lastClosedColor;
        if (JSON.stringify(newRow) !== JSON.stringify(result[index])) {
            state.briefData.splice(index, 1, newRow);
        }
    },
    getProfileAction({ commit }, data) {
        commit("UPDATE_BTN_STATUS", true);
        getPageProfile(data).then((res) => {
            if (res.data.length == 0) {
                commit("UPDATE_ALL_PROFILE", [
                    { id: 0, text: "default", books: [] },
                ]);
                commit("UPDATE_SELECTED_PROFILE", {
                    id: 0,
                    text: "default",
                    books: [],
                });
            } else {
                const returnedProfileList = res.data.map((profile) => {
                    return {
                        id: profile.id,
                        text: profile.profile_name,
                        books: JSON.parse(profile.value).unselected_books,
                    };
                });
                commit("UPDATE_ALL_PROFILE", returnedProfileList);

                const homeId = parseInt(localStorage.getItem("homeId"));
                if (homeId) {
                    if (
                        returnedProfileList.find((item) => item.id === homeId)
                    ) {
                        commit(
                            "UPDATE_SELECTED_PROFILE",
                            returnedProfileList.find(
                                (item) => item.id === homeId
                            )
                        );
                    } else {
                        commit(
                            "UPDATE_SELECTED_PROFILE",
                            returnedProfileList[0]
                        );
                    }
                } else {
                    commit("UPDATE_SELECTED_PROFILE", returnedProfileList[0]);
                }
            }
        });
    },
    putProfileAction({ commit }, data) {
        commit("UPDATE_LOADING", true);

        putPageProfile(data).then(() => {
            commit("UPDATE_EDITING_DIALOG", false);
            commit("CHANGE_UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    postProfileAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        postPageProfile(data).then(() => {
            commit("UPDATE_EDITING_DIALOG", false);
            commit("CHANGE_UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    deletePageProfileAction({ commit, state }, data) {
        deletePageProfile(data).then(() => {
            const remaining = state.allProfile.filter(
                (profile) => profile.id != data.id
            );
            if (remaining.length) {
                commit("UPDATE_ALL_PROFILE", remaining);
            } else {
                commit("UPDATE_ALL_PROFILE", [
                    { id: 0, text: "default", books: [] },
                ]);
                commit("UPDATE_EDITING_DIALOG", false);
            }
        });
    },
    getPNLSummaryAction({ commit }, data) {
        commit("UPDATE_TABLE_LOADING", true);
        commit("UPDATE_PNL_SUMMARY_DATA", []);
        getPNLSummary(data).then((res) => {
            res.data.forEach((item) => {
                item.realized_eod = item.realized_eod.toFixed(2);
                item.realized_mt4 = item.realized_mt4.toFixed(2);
            });
            commit("UPDATE_PNL_SUMMARY_DATA", res.data);
            commit("UPDATE_TABLE_LOADING", false);
        });
    },
    updateHomeTutorialAction({ state }, data) {
        state.homeTutorial = data;
    },
    updateHomeSymbolTutorialAction({ state }, data) {
        state.homeSymbolTutorial = data;
    },
    updateHomeSymbolSnapshotTutorialAction({ state }, data) {
        state.homeSymbolSnapshotTutorial = data;
    },
    updateLoginTradesTutorialAction({ state }, data) {
        state.homeLoginTradesTutorial = data;
    },
    updateLoginInfoTutorialAction({ state }, data) {
        state.homeLoginInfoTutorial = data;
    },
    updateLoginSnapshotTutorialAction({ state }, data) {
        state.homeLoginSnapshotTutorial = data;
    },
};

const mutations = {
    UPDATE_MAIN_BOOK_TITLE(state, data) {
        state.mainBookTitle = data;
    },
    UPDATE_BRIEF_DATA(state, data) {
        state.briefData = data;
    },
    UPDATE_BOOKS(state, data) {
        state.bookMap = null;
        state.briefData = [];
        function flattenBooks(items, parent, depth) {
            const result = [];
            for (const item of items) {
                result.push({
                    name: item.book_name,
                    parent: parent,
                    depth: depth,
                    children: item.children
                        ? item.children.map((c) => c.book_name)
                        : null,
                });
                if (item.children) {
                    result.push(
                        ...flattenBooks(
                            item.children,
                            item.book_name,
                            depth + 1
                        )
                    );
                }
            }
            return result;
        }
        const result = flattenBooks(data, null, 0);
        state.bookMap = result;
        for (var i = 0; i < result.length; i++) {
            const preset = {
                book: result[i].name,
                NPNL: 0,
                CPNL: 0,
                FPNL: 0,
                dailyVolumeUSD: 0,
                NetEquity: 0,
                lxp1: "None",
                vol: 0,
                mtdPnl: 0,
                mtdVol: 0,
                isChild: result[i].parent !== null,
                hasChildren: !!result[i].children,
                depth: result[i].depth,
                parentBook: result[i].parent,
            };
            state.briefData.push(preset);
        }
        state.books = data;
    },
    UPDATE_SELECTED_BOOK(state, data) {
        state.selectedBook = data;
    },
    UPDATE_EXPOSURE_DATA(state, data) {
        state.exposureData = data;
    },
    UPDATE_PNL_SUMMARY_DATA(state, data) {
        state.PNLSummaryData = data;
    },
    UPDATE_SOCKET_CONNECTION_STATUS(state, data) {
        state.isSocketConnected = data;
    },
    UPDATE_ALL_BOOK_OPTIONS(state, data) {
        state.allBookOptions = data;
    },
    UPDATE_SELECTED_PROFILE(state, data) {
        if (data !== null && localStorage.getItem("homeId") !== data.id) {
            localStorage.setItem("homeId", data.id);
        }
        state.selectedProfile = data;
    },
    UPDATE_ALL_PROFILE(state, data) {
        localStorage.setItem("homeProfiles", JSON.stringify(data));
        state.allProfile = data;
        // state.isBtnDisabled = false;
    },
    UPDATE_EDITING_DIALOG(state, data) {
        state.editingDialog = data;
    },
    CHANGE_UPDATE_STATUS(state, data) {
        state.updated = data;
    },
    UPDATE_BTN_STATUS(state, data) {
        state.isBtnDisabled = data;
    },
    UPDATE_LOADING(state, data) {
        state.dialogLoading = data;
    },
    UPDATE_ALL_BOOK_HEADER(state, data) {
        state.briefHeader.find((item) => item.value == data.target).align =
            data.alignment;
        state.briefChildrenHeader.find(
            (item) => item.value == data.target
        ).align = data.alignment;
    },
    UPDATE_TABLE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_SELECTED_INTERVAL(state, data) {
        state.selectedInterval = data;
    },
    UPDATE_SYMBOL_SNAPSHOT(state, data) {
        state.symbolSnapshotData = data;
    },
    UPDATE_LOGIN_SNAPSHOT(state, data) {
        state.loginSnapshotData = data;
    },
    UPDATE_LOT_DIGITS(state, data) {
        state.lotDigits = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
